'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var InternalBadge_web = require('../../internal/InternalBadge/InternalBadge.web.cjs');
require('@emotion/react');
require('../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
require('../../../../../../_virtual/index.cjs');
require('react');
require('@remix-run/react');
require('react-router-dom');
require('../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../Typography/Typography.web.cjs');
require('../../internal/InternalToggle/InternalToggle.web.cjs');

/**
 * The Badge component is a small, contextual UI element used to display short, informative text such as counts.
 * It helps highlight key information or draw attention to items within an interface.
 *
 * {@link https://aviary.fullscript.io/latest/components/badge/web-quZRSyVY | Documentation}
 *
 * {@link https://git.fullscript.io/developers/aviary/-/blob/development/packages/aviary-web/src/components/atoms/Badge/Badge.web.tsx | View in GitLab}
 *
 * @scope Core
 */ const Badge = ({ count, size = "medium", ...rest })=>{
    const isNumberAboveZero = Number.isInteger(count) && count && count >= 0;
    const renderCountDisplay = ()=>{
        if (!isNumberAboveZero || size !== "medium") return null;
        const countDisplay = count > 99 ? "99+" : count;
        return countDisplay;
    };
    return /*#__PURE__*/ jsxRuntime.jsx(InternalBadge_web.InternalBadge, {
        size: size,
        ...rest,
        children: renderCountDisplay()
    });
};

exports.Badge = Badge;
//# sourceMappingURL=Badge.web.cjs.map
